import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { ShopinfoService } from '../../system/shopinfo/shopinfo.service';
import { ShopinfoModel } from '../../system/shopinfo/model/shopinfo.model';
import { WeeklyResultByStoreReportService } from '../weekly-result-by-store-report/weekly-result-by-store-report.service';
import { WeeklyResultByBranchService } from './weekly-result-by-branch.service';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-weekly-result-by-branch',
  standalone: false,
  templateUrl: './weekly-result-by-branch.component.html',
  styleUrl: './weekly-result-by-branch.component.scss'
})
export class WeeklyResultByBranchComponent {

  title: string = "Weekly Result By Branch";
  IsDownloading: boolean = false;
  editForm: FormGroup;
  currentYear: number;
  // years: number[];
  selectedYear: any;
  weeks: any[] = [];
  shopListData: any = [];
  shopFilter: string = '';
  isExpandedShop = false;
  resetButtonEnabledForShop: boolean = false;
  showSelectedShopOnly: boolean = false;
  permission: any;
  selectedShopType: 'shop' | 'dt' = 'shop';

  onShopTypeChange(value: 'shop' | 'dt'): void {
    this.selectedShopType = value;
    this.editForm.get('shopFilterAll')?.setValue('');
  }


  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private weeklyResultByBranchService: WeeklyResultByBranchService,
    private snackBarService: SnackBarService,
    private ShopinfoService: ShopinfoService,
    private permissionService: PermissionService,
    public dialog: MatDialog,) {

    let uomId = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      // year: this.builder.control( ''),
      year: this.builder.control(null),
      week_no: this.builder.control([]),
      description: this.builder.control([]),
      decimal_places: this.builder.control([]),
      uom_symbol: this.builder.control([]),
      compound_unit: this.builder.control([]),
      //base_uom_id: [this.uomInfo.selectedBaseUom], // Add this line
      base_uom_id: this.builder.control([]), // Add this line
      sort_by: this.builder.control('shop_name'),
      shopFilter: this.builder.control(''),
      shopFilterAll: this.builder.control(''),
      shopFilterSelected: this.builder.control(''),
      sort_order: this.builder.control('asc')




    });

    this.currentYear = new Date().getFullYear();
    // this.years = this.generateYears();

    // Automatically save to sessionStorage when form values change
    this.editForm.valueChanges.subscribe(() => {
      this.saveToSessionStorage();
    });
    this.editForm.get('shopFilter')?.valueChanges.subscribe((value: string) => {
      this.shopFilter = value;
    });

    // Load saved data if it exists
    // this.loadFromSessionStorage();
    this.permission = permissionService.getPagePermission("weekly-result-by-branch")
    console.log(this.permission);
  }
  // getCurrentWeek(weeks: any[]): any {
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0); // Normalize time to midnight for accurate comparison

  //   return weeks.find(week => {
  //     const startDate = new Date(week.start_date);
  //     const endDate = new Date(week.end_date);
  //     return today >= startDate && today <= endDate;
  //   });
  // }

  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }

  sortOptions = [
    { value: 'shop_name', label: 'Shop Name' },
    { value: 'this_year_this_week_sales', label: 'This Year Sales' },
    { value: 'last_year_this_week_sales', label: 'Last Year Sales' },
    { value: 'this_week_cust_orders', label: 'This Year Customer Orders' },
    { value: 'last_year_cus_order', label: 'Last Year Customer Orders' },
    { value: 'this_week_labour_cost', label: 'This Year Labour Cost' },
    { value: 'last_year_this_week_labour_cost', label: 'Last Year Labour Cost' },
  ];

  sortOrderOptions = [
    { value: 'asc', label: 'Ascending' },
    { value: 'desc', label: 'Descending' }
  ];

  saveToSessionStorage(): void {
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    const selectedShopIds = this.shopListData
      .filter((shop: any) => {
        if (!shop.selected) return false;
        const isDt = shop.item.name && shop.item.name.toUpperCase().includes(' DT');
        return this.selectedShopType === 'dt' ? isDt : !isDt;
      })
      .map((shop: any) => shop.item.id);

    // If no shops are selected, we treat it as "ALL" (empty array means all shops)
    const shopIds = selectedShopIds.length > 0 ? selectedShopIds : [];

    // Create the data object
    const reportData = {
      year: this.editForm.get('year')?.value,
      weekNo: this.editForm.get('week_no')?.value,
      shopId: shopIds,
      sortBy: this.editForm.get('sort_by')?.value,
      sortDir: this.editForm.get('sort_order')?.value,
      isExport: 0
    };

    // Save to sessionStorage
    sessionStorage.setItem('weeklyBranchReportData', JSON.stringify(reportData));
  }

  loadFromSessionStorage(): void {
    const savedData = sessionStorage.getItem('weeklyBranchReportData');
    if (savedData) {
      const reportData = JSON.parse(savedData);

      // Set form values
      this.editForm.patchValue({
        year: reportData.year,
        week_no: reportData.weekNo,
        sort_by: reportData.sortBy,
        sort_order: reportData.sortDir
      }, { emitEvent: false }); // Prevent infinite loop

      // Set shop selections (if shop IDs were saved)
      if (reportData.shopId && reportData.shopId.length > 0) {
        this.shopListData.forEach((shop: any) => {
          shop.selected = reportData.shopId.includes(shop.item.id);
        });
      } else {
        // If no shops were selected before, reset all to false (treat as "ALL")
        this.shopListData.forEach((shop: any) => shop.selected = false);
      }

      // Manually trigger year change if needed
      if (reportData.year) {
        this.onYearChange();
      }
    }
  }
  ngOnInit(): void {
    this.loadData();
    this.shopList();

  }


  onYearChange(): void {
    this.selectedYear = this.editForm.get('year')?.value;
    console.log('Selected Year:', this.selectedYear);

    // Find the selected financial year from financialYears array
    const selectedFinYear = this.financialYears.find(fy => fy.year === this.selectedYear);

    if (selectedFinYear) {
      // Filter weeks to only show those that have started
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const filteredWeeks = selectedFinYear.weeks.filter((week: any) => {
        const weekStartDate = new Date(week.start_date);
        weekStartDate.setHours(0, 0, 0, 0);
        return weekStartDate <= today;
      });

      // Sort weeks in descending order by week number
      this.weeks = filteredWeeks
        .map((week: any) => ({
          ...week,
          displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
        }))
        .sort((a: any, b: any) => b.week_no - a.week_no);

      // Set the first week as default if weeks exist
      if (this.weeks.length > 0) {
        this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.editForm.get('week_no')?.setValue(null);
    }
  }


  financialYears: any[] = []; // This will store the finYears array from API
  years: number[] = []; // This will store just the year numbers if needed separately
  curFinYear!: string; // Add this to your component properties

  buildRequestData(): any {
    return {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: "100",
            offset: "0"
          }
        },
        sort: [
          {
            column: "wd.year",
            order: "desc"
          }
        ]
      }
    };

  }

  loadData(): void {
    console.log('Selected Year:', this.selectedYear);
    let requestData = this.buildRequestData();
    this.weeklyResultByBranchService.getWeekNoList(requestData).subscribe(response => {
      console.log('API Response:', response);

      if (response.status === 'SUCCESS') {
        // Filter financial years to show only those that have actually started
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        this.financialYears = response.data.finYears
          .filter((fy: any) => {
            // If the financial year has weeks, check if the first week has started
            if (fy.weeks && fy.weeks.length > 0) {
              // Sort weeks to get the first week by week number
              const sortedWeeks = fy.weeks.sort((a: any, b: any) => a.week_no - b.week_no);
              const firstWeek = sortedWeeks[0];
              const firstWeekStartDate = new Date(firstWeek.start_date);
              firstWeekStartDate.setHours(0, 0, 0, 0);

              // Only show financial years whose first week has started
              return firstWeekStartDate <= today;
            }
            // If no weeks data, fall back to year comparison
            return fy.year <= today.getFullYear();
          })
          .sort((a: any, b: any) => b.year - a.year);
        this.years = this.financialYears.map(fy => fy.year);

        // Only set the default value if the form control is empty
        if (!this.editForm.get('year')?.value) {
          this.curFinYear = response.data.curFinYear;
          if (this.curFinYear) {
            const yearValue = parseInt(this.curFinYear);
            this.editForm.get('year')?.setValue(yearValue, { emitEvent: false });

            // Set weeks for the current financial year
            const currentFinYear = this.financialYears.find(fy => fy.year === yearValue);
            if (currentFinYear) {
              // Filter weeks to only show those that have started
              const today = new Date();
              today.setHours(0, 0, 0, 0);

              const filteredWeeks = currentFinYear.weeks.filter((week: any) => {
                const weekStartDate = new Date(week.start_date);
                weekStartDate.setHours(0, 0, 0, 0);
                return weekStartDate <= today;
              });

              // Sort weeks in descending order by week number
              this.weeks = filteredWeeks
                .map((week: any) => ({
                  ...week,
                  displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date} - ${week.end_date})`
                }))
                .sort((a: any, b: any) => b.week_no - a.week_no);

              const currentWeek = this.getCurrentWeek(this.weeks);
              if (currentWeek) {
                this.editForm.get('week_no')?.setValue(currentWeek.week_no);
              } else if (this.weeks.length > 0) {
                this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
              }
            }
          }
        }

        console.log('Financial Years Data:', this.financialYears);
      } else {
        console.error('API Error:', response.message);
      }
    });
  }
  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, '0');
  }



  shopList(): void {

    let requestData = { search: { filters: { filter: [], scope: { offset: 0, limit: 1000000 } }, sort: [{ column: "shop.name", order: "ASC" }] } }

    this.ShopinfoService.getShopList(requestData).subscribe(
      (response: any) => {
        this.shopListData = [];
        var index = 0;
        response.data.shops.forEach((item: any) => {
          if (item.name) {
            var data = { index: index, item: item, selected: false };
            this.shopListData.push(data);
            index++;
          }
        });
        this.updateResetButtonStateForShop(); // <-- update reset button state after loading
      },
      (error: any) => {

      },
    );
  }






  updateResetButtonStateForShop(): void {
    this.resetButtonEnabledForShop = this.shopListData?.some((shop: any) => shop.selected);
  }


  resetShopSelection(): void {
    this.shopListData.forEach((shop: any) => shop.selected = false);
    this.updateResetButtonStateForShop();
    this.saveToSessionStorage();
  }

  // --- End Drop/Reset Functionality ---

  // Filter logic for shop list (like applyFilter in your dialog)
  applyShopFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.editForm.get('shopFilter')?.setValue(filterValue);
  }

  get filteredShopListData() {
    let filteredList = this.shopListData;
    if (this.selectedShopType === 'dt') {
      filteredList = filteredList.filter((item: any) => item.item.name && item.item.name.toUpperCase().includes(' DT'));
    } else {
      filteredList = filteredList.filter((item: any) => !item.item.name || !item.item.name.toUpperCase().includes(' DT'));
    }
    if (this.showSelectedShopOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('shopFilterAll')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }

  toggleSelectAllShop() {
    const currentTypeShops = this.shopListData.filter((item: any) => {
      const isDt = item.item.name && item.item.name.toUpperCase().includes(' DT');
      return this.selectedShopType === 'dt' ? isDt : !isDt;
    });
    const allSelected = currentTypeShops.every((item: any) => item.selected);
    currentTypeShops.forEach((item: any) => (item.selected = !allSelected));
    this.updateResetButtonStateForShop();
    this.saveToSessionStorage();
  }

  getSelectAllIconShop(): string {
    const currentTypeShops = this.shopListData.filter((item: any) => {
      const isDt = item.item.name && item.item.name.toUpperCase().includes(' DT');
      return this.selectedShopType === 'dt' ? isDt : !isDt;
    });
    const allSelected = currentTypeShops.every((item: any) => item.selected);
    const someSelected = currentTypeShops.some((item: any) => item.selected);

    if (allSelected) {
      return 'check_box';
    }
    if (someSelected) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  get selectedShopSourcesCount(): number {
    return this.shopListData?.filter((item: any) => {
      if (!item.selected) return false;
      const isDt = item.item.name && item.item.name.toUpperCase().includes(' DT');
      return this.selectedShopType === 'dt' ? isDt : !isDt;
    })?.length || 0;
  }



  getSelectedCount(sourceList: any[]): any {
    var count = 0;
    sourceList.forEach(el => {
      if (el.selected) {
        count++;
      }
    })
    return sourceList.length + '/' + ((count > 0) ? (count) : 'ALL');
  }





  onShopSelectionChange(): void {
    this.updateResetButtonStateForShop();
    this.saveToSessionStorage();
  }

  navigateToWeeklyReport() {
    this.router.navigate(['/report/weekly-result-by-branch-view']);
    // or with parameters if needed:
    // this.router.navigate(['/weekly-result-store-report-view', {param: value}]);
  }

  exportClicked(): void {
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    this.IsDownloading = true;
    const selectedShopIds = this.shopListData
      .filter((shop: any) => {
        if (!shop.selected) return false;
        const isDt = shop.item.name && shop.item.name.toUpperCase().includes(' DT');
        return this.selectedShopType === 'dt' ? isDt : !isDt;
      })
      .map((shop: any) => shop.item.id);

    // If no shops are selected, we treat it as "ALL" (empty array means all shops)
    const shopIds = selectedShopIds.length > 0 ? selectedShopIds : [];

    // Create the data object
    const reportData = {
      year: this.editForm.get('year')?.value,
      weekNo: this.editForm.get('week_no')?.value,
      shopId: shopIds,
      sortBy: this.editForm.get('sort_by')?.value,
      sortDir: this.editForm.get('sort_order')?.value,
      isExport: 1
    };
    if (reportData) {
      this.IsDownloading = true;

      this.weeklyResultByBranchService.getWeekBranchExportList(reportData).subscribe({
        next: (response: Blob) => {
          const reader = new FileReader();

          reader.onload = () => {
            try {
              const text = reader.result as string;
              const json = JSON.parse(text);

              // Check for no data found status
              if (json.status === 'NO_DATA_FOUND') {
                let snackBarData: SnackBarData = {
                  message: 'No data found.',
                  title: 'No Data Found!',
                  type: 'warn'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Check for other error statuses
              if (json.status === 'ERROR' || json.status === 'FAILED') {
                let snackBarData: SnackBarData = {
                  message: json.message || 'An error occurred while generating the report.',
                  title: 'Error!',
                  type: 'error'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // If we reach here with a JSON response, show warning
              let snackBarData: SnackBarData = {
                message: 'Unexpected response format from server.',
                title: 'Warning!',
                type: 'warn'
              }
              this.IsDownloading = false;
              this.snackBarService.openSnackBar(snackBarData);

            } catch (e) {
              // If JSON parsing fails, it's likely a binary file (Excel)
              // Check if the response is empty or very small
              if (response.size === 0) {
                let snackBarData: SnackBarData = {
                  message: 'No data available for export.',
                  title: 'No Data Found!',
                  type: 'warn'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Check if response is too small to be a valid file
              if (response.size < 100) {
                let snackBarData: SnackBarData = {
                  message: 'No data found.',
                  title: 'No Data Found!',
                  type: 'warn'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }

              // Valid binary file - proceed with download
              const blob = new Blob([response], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'weekly-report-by-branch.xlsx';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.IsDownloading = false;

              // Show success message
              let snackBarData: SnackBarData = {
                message: 'Report downloaded successfully.',
                title: 'Success!',
                type: 'success'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          };

          reader.readAsText(response);
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          this.IsDownloading = false;

          let snackBarData: SnackBarData = {
            message: 'An error occurred while fetching the report. Please try again.',
            title: 'Error!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    }


  }


}
